module.exports = __webpack_public_path__ + "img/works3.6e102bc1.jpg";